<section>
    <h1>{{ title }}</h1>
    <img src="../../../../../assets/images/no-data.svg" alt="no-data">
</section>
